import { useParams, Link } from 'react-router-dom';
import { ChevronRight, Music, Play, ArrowRight, Mic2, Star } from 'lucide-react';
import './GenreDetail.css';

const genreData = {
  'bollywood-hits': {
    title: 'Bollywood Hits',
    tagline: 'The Soul of Indian Cinema',
    img: '/Assets/p1.jpg.jpeg',
    desc: 'From evergreen classics of the golden era to the latest chartbusters, we bring the magic of Bollywood to life. Our performances capture the energy, romance, and vibrancy that define Indian cinema, ensuring a night of non-stop entertainment and dancing.',
    features: ['Latest Chartbusters', 'Retro Classics', 'Dance Mashups', 'Romantic Melodies']
  },
  'english-retros': {
    title: 'English Retros',
    tagline: 'Timeless Classics from the West',
    img: '/Assets/p2.jpg.jpeg',
    desc: 'Take a trip down memory lane with the best of English Pop, Rock, and Jazz from the 70s, 80s, and 90s. We perform hits from legendary artists, bringing a sophisticated yet energetic vibe to your corporate events and private parties.',
    features: ['70s & 80s Pop', 'Classic Rock', 'Smooth Jazz', 'Disco Hits']
  },
  'sufi-geet': {
    title: 'Sufi Geet',
    tagline: 'Divine Melodies for the Soul',
    img: '/Assets/p3.jpg.jpeg',
    desc: 'Experience the spiritual and soulful world of Sufi music. With powerful vocals and traditional instruments, we create an atmosphere of peace and divinity, performing both traditional kalams and modern Sufi-rock fusions.',
    features: ['Traditional Qawwalis', 'Sufi-Rock Fusion', 'Nusrat Sahab Classics', 'Soulful Meditations']
  },
  'ghazals': {
    title: 'Ghazals',
    tagline: 'Poetry in Motion',
    img: '/Assets/p4.jpg.jpeg',
    desc: 'For those who appreciate the finer nuances of poetry and music, our Ghazal performances are a treat. We bring deep emotions and intricate melodies to life, creating a sophisticated and intimate musical experience.',
    features: ['Classic Ghazals', 'Poetry Recitals', 'Intimate Settings', 'Traditional Compositions']
  },
  'indian-classical': {
    title: 'Indian Classical',
    tagline: 'The Raagas of Tradition',
    img: '/Assets/p5.jpg.jpeg',
    desc: 'Immerse yourself in the rich heritage of Indian Classical music. Our trained artists perform Raagas and compositions that showcase the depth and technical brilliance of our ancient musical traditions.',
    features: ['Vocal Classical', 'Instrumental Jugalbandi', 'Fusion Experiments', 'Rhythmic Mastery']
  },
  'folk-fusion': {
    title: 'Folk Fusion',
    tagline: 'The Rhythm of the Earth',
    img: '/Assets/p6.jpg.jpeg',
    desc: 'Experience the raw energy of Rajasthani folk blended with modern sounds. Our Folk Fusion performances are high-energy, colorful, and deeply rooted in the traditions of our land, perfect for welcoming guests and grand celebrations.',
    features: ['Rajasthani Folk', 'Modern Beats', 'Traditional Dancers', 'International Fusion']
  }
};

export default function GenreDetail() {
  const { id } = useParams();
  const genre = genreData[id];

  if (!genre) {
    return (
      <div className="error-page container" style={{ padding: '120px 24px', textAlign: 'center' }}>
        <h1>Genre Not Found</h1>
        <Link to="/" className="btn-primary" style={{ marginTop: 24 }}>Return Home</Link>
      </div>
    );
  }

  return (
    <div className="genre-detail">
      <div className="genre-hero" style={{ backgroundImage: `url(${genre.img})` }}>
        <div className="hero-overlay" />
        <div className="container hero-content">
          <span className="genre-badge animate-fadeInUp"><Music size={14} /> {genre.tagline}</span>
          <h1 className="animate-fadeInUp delay-1">{genre.title}</h1>
          <div className="red-line animate-fadeInUp delay-2" />
        </div>
      </div>

      <section className="genre-info-section">
        <div className="container">
          <div className="genre-info-grid">
            <div className="info-text animate-fadeInUp">
              <span className="section-tag">About The Repertoire</span>
              <h2>A Musical Journey Through {genre.title}</h2>
              <p>{genre.desc}</p>
              
              <div className="genre-features">
                {genre.features.map((f, i) => (
                  <div key={i} className="feature-item">
                    <Star size={18} className="feature-icon" />
                    <span>{f}</span>
                  </div>
                ))}
              </div>

              <div className="genre-cta">
                <Link to="/contact" className="btn-primary">Book For Your Event <ChevronRight size={16} /></Link>
              </div>
            </div>

            <div className="info-visual animate-fadeInUp delay-2">
              <div className="visual-card">
                <img src={genre.img} alt={genre.title} />
                <div className="visual-overlay">
                   <Mic2 size={48} color="white" />
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-num">500+</div>
                <div className="stat-label">{genre.title} Shows</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="genre-bottom-cta">
        <div className="container">
          <div className="cta-box card">
            <div className="cta-text">
              <h2>Ready to Experience The Best {genre.title}?</h2>
              <p>Contact us today to book Jimmy'z Band for your next special occasion.</p>
            </div>
            <Link to="/contact" className="btn-gold">Get a Free Quote <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
